import React, { useMemo, useContext } from "react";
import PropTypes from "prop-types";
import { RightsContext } from "providers/RightsContext";
import { hasAuthorization } from "utils/functions";
import * as rightsCodes from "constants/rightsCodes";
import { Switch, Route, Redirect } from "react-router-dom";
import Dashboard from "../features/dashboard/components/Dashboard";
import SettingsContainer from "../components/settings/SettingsContainer";
import Container from "../features/partner/components/Container";
import LogContainer from "features/logs/components/LogContainer";
import DetailsContainer from "features/logs/components/DetailsContainer";
import { connect } from "react-redux";
import List from "features/partner/components/List";
import BalanceSheetDetailsTabsContainer from "features/partner/components/balanceSheet/details/BalanceSheetDetailsTabsContainer";
import HierarchyContainer from "features/hierarchies/edit/HierarchyContainer";
import HierarchiesListBrowser from "features/hierarchies/list/HierarchyListBrowser";
import Forbidden from "components/common/Forbidden";

const ProtectedRoute = ({ component: Component, validUser, permission, ...rest }) => {
  const rightsContext = useContext(RightsContext);
  const hasPermission = permission ? hasAuthorization(permission, rightsContext) : true;

  return (
    <Route
      {...rest}
      render={props =>
        validUser ? (
          hasPermission ? (
            <Component {...props} />
          ) : (
            <Redirect to="/forbidden" />
          )
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

ProtectedRoute.propTypes = {
  component: PropTypes.elementType,
  validUser: PropTypes.bool,
  permission: PropTypes.string,
};

const AppRoutes = ({ user }) => {
  const validUser = useMemo(() => user && !user.expired, [user]);

  return (
    <Switch>
      <Route exact path="/">
        <Redirect to="/dashboard" />
      </Route>
      <ProtectedRoute path="/dashboard" component={Dashboard} validUser={validUser} />
      <ProtectedRoute exact path="/partners" component={List} validUser={validUser} />
      <ProtectedRoute exact path="/partners/new" component={Container} validUser={validUser} />
      <ProtectedRoute path="/partners/:partnerId" component={Container} validUser={validUser} />
      <ProtectedRoute exact path="/banks" component={List} validUser={validUser} />
      <ProtectedRoute exact path="/banks/new" component={Container} validUser={validUser} />
      <ProtectedRoute exact path="/partnerHierarchies" component={HierarchiesListBrowser} validUser={validUser} permission={rightsCodes.MASTER_PARTNER_HIERARCHIES_READ} />
      <ProtectedRoute exact path="/partnerHierarchies/new" component={HierarchyContainer} validUser={validUser} permission={rightsCodes.MASTER_PARTNER_HIERARCHIES_READ} />
      <ProtectedRoute path="/partnerHierarchies/:partnerHierarchyId" component={HierarchyContainer} validUser={validUser} permission={rightsCodes.MASTER_PARTNER_HIERARCHIES_READ} />
      <ProtectedRoute path="/banks/:partnerId" component={Container} validUser={validUser} />
      <ProtectedRoute exact path="/selfPartner" component={List} validUser={validUser} />
      <ProtectedRoute path="/selfPartner/:partnerId" component={Container} validUser={validUser} />
      <ProtectedRoute path="/balanceSheetDetails/:balanceSheetId" component={BalanceSheetDetailsTabsContainer} validUser={validUser} />
      <ProtectedRoute path="/settings" component={SettingsContainer} validUser={validUser} />
      <ProtectedRoute exact path="/logs" component={LogContainer} validUser={validUser} />
      <ProtectedRoute path="/logs/:keyId" component={DetailsContainer} validUser={validUser} />
      <Route exact path="/forbidden" component={Forbidden} />
      <Route path="*">
        <Redirect to="/" />
      </Route>
    </Switch>
  );
};

function mapStateToProps(state) {
  return {
    user: state.oidc.user
  };
}

AppRoutes.propTypes = {
  user: PropTypes.object
};

export default connect(mapStateToProps)(AppRoutes);
